import { render, staticRenderFns } from "./JK_todo.vue?vue&type=template&id=fc140f9e&scoped=true"
import script from "./JK_todo.vue?vue&type=script&lang=js"
export * from "./JK_todo.vue?vue&type=script&lang=js"
import style0 from "./JK_todo.vue?vue&type=style&index=0&id=fc140f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc140f9e",
  null
  
)

export default component.exports